module.exports = __webpack_public_path__ + "translations/en/userportal.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/userportal.json
// module id = ./translations/en/userportal.json
// module chunks = 1